import classNames from 'classnames';
import { type FC, useMemo } from 'react';

import GamesList from 'components/GamesList';
import { CasinoGroup } from 'utils/casino';
import useLayout from 'utils/layout';

import MoreProviders from './MoreProviders';

import styles from './ProviderGamesPage.module.scss';

type ProviderGamesProps = {
  provider: string;
  search?: string;
  sortDirection?: 'asc' | 'desc';
};

const ProviderGames: FC<ProviderGamesProps> = ({
  provider,
  search,
  sortDirection,
}) => {
  const layout = useLayout();
  const providers = useMemo(() => [provider], [provider]);

  return (
    <div className={classNames(styles.games, styles[layout])}>
      <div className={styles['games-list-wrapper']}>
        <GamesList
          group={CasinoGroup.CASINO}
          providers={providers}
          slice={28}
          name={search}
          sortDirection={sortDirection}
        />
      </div>
      <MoreProviders />
    </div>
  );
};

export default ProviderGames;
